import axios from 'axios';
import config from '../config';

// ============================================
// CLIENTES AXIOS
// ============================================

/**
 * Cliente API V0 (Legacy)
 * Usado para endpoints existentes que aún no han migrado a V1
 */
export const apiV0 = axios.create({
  baseURL: `${config.API_BASE_URL}/api`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

/**
 * Cliente API V1 (Nueva arquitectura)
 * Usado para endpoints migrados con configuración dinámica
 */
export const apiV1 = axios.create({
  baseURL: `${config.API_BASE_URL}/api/v1`,
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' }
});

// ============================================
// TOKEN MANAGER
// ============================================

export const tokenManager = {
  /**
   * Obtiene el token actual desde localStorage
   * @returns {string|null} Token JWT o null si no existe
   */
  getToken: () => {
    const user = localStorage.getItem('user');
    if (!user) return null;
    try {
      const userData = JSON.parse(user);
      return userData.token || null;
    } catch (e) {
      console.error('Error parseando user de localStorage:', e);
      return null;
    }
  },

  /**
   * Actualiza el token en localStorage manteniendo los demás datos del usuario
   * @param {string} token - Nuevo token JWT
   */
  setToken: (token) => {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        const userData = JSON.parse(user);
        userData.token = token;
        localStorage.setItem('user', JSON.stringify(userData));
      } catch (e) {
        console.error('Error actualizando token:', e);
      }
    }
  },

  /**
   * Limpia completamente el token y datos de usuario
   */
  clearToken: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  }
};

// ============================================
// INTERCEPTORES DE REQUEST
// ============================================

/**
 * Interceptor que adjunta automáticamente el token Bearer en cada request
 */
const attachTokenInterceptor = (client) => {
  client.interceptors.request.use(
    (config) => {
      const token = tokenManager.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

// Aplicar a ambos clientes
attachTokenInterceptor(apiV0);
attachTokenInterceptor(apiV1);

// ============================================
// INTERCEPTORES DE RESPONSE
// ============================================

/**
 * NOTA: El auto-refresh de tokens ahora se maneja en axiosConfig.js
 * de forma global para TODAS las instancias de axios.
 *
 * No necesitamos duplicar la lógica aquí porque axiosConfig.js
 * se carga antes que la app y afecta a apiV0, apiV1 y cualquier
 * llamada directa a axios.
 */

// ============================================
// EXPORTACIONES
// ============================================

const apiClient = {
  apiV0,
  apiV1,
  tokenManager
};

export default apiClient;
